import styled from "styled-components/macro";

export const NftRoot = styled('div')`
  min-height: 448px;
  max-width: 293.33px;
  text-align: center;
  h3 {
    font-size: 26px;
    font-weight: bold;
    margin-top: 20px;
    margin-bottom: 5px;
  }
  p {
    font-size: 19px;
  }
  button {
    max-width: 100%;
  }
`;
export const NftImg = styled('img')`
  max-width: 100%;
  max-width: 
  width: 100%;
  border-radius: 20px;
`;
export const MultiplierBox = styled('p')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
  font-size: 14px !important;
`;
export const ButtonGroup = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 900px) {
    flex-wrap: wrap;
  }

  gap: 10px;
  margin-top: 15px;

  button {
    font-size: 12px !important;
    padding: 8px 15px !important;
    width: 100%;

    font-size: 15px;
    font-family: Oswald;
    color: rgb(255, 255, 255);
    font-weight: bold;
    text-transform: uppercase;
    height: fit-content;
    background-color: rgb(43, 43, 43);
    border: none;
    border-radius: 8px;
    padding: 10px 25px;
    cursor: pointer;

    @media (max-width: 900px) {
      width: 100%;
    }
  }
`;

export const Title = styled.h3`
  font-size: 24px !important;
  text-align: left;
  font-family: Oswald !important;
  color: rgb(255, 255, 255) !important;
  font-weight: normal !important;
`;